import router from '@/router'
import { AppHeader } from '@/components'

export default () => {
  router.addRoute({
    path: '/matches/loans/instant/form',
    name: 'aggregator-form',
    meta: {
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    },
    components: {
      default: () => import('./AggregatorForm.vue'),
      header: AppHeader
    }
  })
}
